<template>
  <div class="w100 Contenido">
    <ModalNuevoEstablecimiento ref="Modal" v-show="ModalVisible" @Cerrar="CerrarModal" />

    <div class="TituloSeccion">
      <font-awesome-icon  icon="users" size="4x" :style="{ color: 'black'}"  class="IconoTituloSeccion fLeft"/>
      <div class="fLeft"><b>{{RetornoAPI._NombreProductor}}</b></div>

      <!-- <div class="fRight mR5 BotonAgregar" @click="NuevoEstablecimiento()">
        +
      </div> -->
      <div class="clear"></div>
    </div>

    <div class="DivInfoData" ref="DivInfoData">
      Info recuperada de fecha: <span ref="FechaData"></span>

      <div class="fRight" @click.stop="ObtenerDatos()">
        <font-awesome-icon  icon="sync-alt" size="4x" :style="{ color: 'white'}"  class="IconoActualizar fLeft"/>
        <!-- Actualizar -->
        <div class="clear"></div>
      </div>

      <div class="clear"></div>
    </div>

    <table>
      <thead>
        <tr>
          <th>Establecimiento</th>
          <th class="pR">
            <font-awesome-icon
            @click.stop="NuevoEstablecimiento()"
            icon="plus-circle" size="4x" :style="{ color: '#005625'}" class="IconoAgregar Centro"/>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="Est in RetornoAPI._Establecimientos" :key="Est._Id">
          <td @click.stop="ClickMenu(Est._Id, $event)">{{ Est._Nombre }}, {{ Est._Localidad }}</td>
          <td class="c3" v-show="AdminLogueado">
            <font-awesome-icon @click.stop="EditarEstablecimiento(Est)"  icon="edit" size="4x" :style="{ color: '#348E54'}"  class="h100 IconoEliminar cP"/>
            <font-awesome-icon @click.stop="EliminarEstablecimiento(Est)"  icon="trash-alt" size="4x" :style="{ color: '#934141'}"  class="h100 IconoEliminar cP"/>
            <div class="MenuOpciones">
              <font-awesome-icon @click.stop="ClickMenu(Est._Id, $event)"  icon="ellipsis-h" size="4x" :style="{ color: '#000'}"  class="h100 IconoEliminar cP"/>
              <div :id="'CM' + Est._Id" class="ContenidoMenu" v-clickoutside="OcultarMenu" :class="{ Visible: (IdMenuVisible==Est._Id)}">
                <div class="SeccionArrastre"></div>
                <!-- Pluviómetro  -->
                <div class="OpcionMenu" v-show="Est._Pluviometro._ID > 0" @click.stop="VerPluviometro(Est._Pluviometro._ID)">
                  <font-awesome-icon icon="eye" size="1x" :style="{ color: '#22878E'}"  class="IconoFontChico"/>
                    Ver Pluviómetro
                    <font-awesome-icon icon="trash-alt" size="1x"
                            v-show="Est._Pluviometro._ID > 0"
                            @click.stop="ConfirmarBajaPluviometro(Est._Pluviometro._ID, Est._Nombre + ', ' + Est._Localidad)"
                            :style="{ color: '#934141'}"  class="IconoFontChico TrashIcon"/>
                  </div>
                <div class="OpcionMenu" v-show="Est._Pluviometro._ID <= 0" @click.stop="AltaPluviometro(Est._Id)">
                  <font-awesome-icon icon="plus-circle" size="1x" :style="{ color: '#359122'}"  class="IconoFontChico"/>
                  Agregar Pluviómetro</div>
                <!-- Freatímetro  -->
                <div class="OpcionMenu" v-show="Est._Freatimetro._ID > 0" @click.stop="VerFreatimetro(Est._Freatimetro._ID)">
                  <font-awesome-icon icon="eye" size="1x" :style="{ color: '#22878E'}"  class="IconoFontChico"/>
                  Ver Freatímetro
                    <font-awesome-icon icon="trash-alt" size="1x"
                            v-show="Est._Freatimetro._ID > 0"
                            @click.stop="ConfirmarBajaFreatimetro(Est._Freatimetro._ID, Est._Nombre + ', ' + Est._Localidad)"
                            :style="{ color: '#934141'}"  class="IconoFontChico TrashIcon"/>
                </div>
                <div class="OpcionMenu" v-show="Est._Freatimetro._ID <= 0" @click.stop="AltaFreatimetro(Est._Id)">
                  <font-awesome-icon icon="plus-circle" size="1x" :style="{ color: '#359122'}"  class="IconoFontChico"/>
                  Agregar Freatímetro
                </div>
                <!-- Veris  -->
                <div class="OpcionMenu" v-show="Est._Veris._ID > 0" @click.stop="VerVeris(Est._Veris._ID)">
                  <font-awesome-icon icon="eye" size="1x" :style="{ color: '#22878E'}"  class="IconoFontChico"/>
                  Ver Ambientación
                    <font-awesome-icon icon="trash-alt" size="1x"
                            v-show="Est._Veris._ID > 0"
                            @click.stop="ConfirmarBajaVeris(Est._Veris._ID, Est._Nombre + ', ' + Est._Localidad)"
                            :style="{ color: '#934141'}"  class="IconoFontChico TrashIcon"/>
                </div>
                <div class="OpcionMenu" v-show="Est._Veris._ID <= 0" @click.stop="AltaVeris(Est._Id)">
                  <font-awesome-icon icon="plus-circle" size="1x" :style="{ color: '#359122'}"  class="IconoFontChico"/>
                  Agregar Ambientación
                </div>
                <!-- Análisis Agua  -->
                <div class="OpcionMenu" v-show="Est._AnalisisAgua._ID > 0" @click.stop="VerAguas(Est._AnalisisAgua._ID)">
                  <font-awesome-icon icon="eye" size="1x" :style="{ color: '#22878E'}"  class="IconoFontChico"/>
                  Ver Análisis Agua Útil
                    <font-awesome-icon icon="trash-alt" size="1x"
                            v-show="Est._AnalisisAgua._ID > 0"
                            @click.stop="ConfirmarBajaAguas(Est._AnalisisAgua._ID, Est._Nombre + ', ' + Est._Localidad)"
                            :style="{ color: '#934141'}"  class="IconoFontChico TrashIcon"/>
                </div>
                <div class="OpcionMenu" v-show="Est._AnalisisAgua._ID <= 0" @click.stop="AltaAguas(Est._Id)">
                  <font-awesome-icon icon="plus-circle" size="1x" :style="{ color: '#359122'}"  class="IconoFontChico"/>
                  Agregar Análisis Agua Útil
                </div>
                <!-- Análisis Suelos  -->
                <div class="OpcionMenu" v-show="Est._AnalisisSuelo._ID > 0" @click.stop="VerSuelo(Est._AnalisisSuelo._ID)">
                  <font-awesome-icon icon="eye" size="1x" :style="{ color: '#22878E'}"  class="IconoFontChico"/>
                  Ver Análisis Suelo
                    <font-awesome-icon icon="trash-alt" size="1x"
                            v-show="Est._AnalisisSuelo._ID > 0"
                            @click.stop="ConfirmarBajaSuelo(Est._AnalisisSuelo._ID, Est._Nombre + ', ' + Est._Localidad)"
                            :style="{ color: '#934141'}"  class="IconoFontChico TrashIcon"/>
                </div>
                <div class="OpcionMenu" v-show="Est._AnalisisSuelo._ID <= 0" @click.stop="AltaSuelo(Est._Id)">
                  <font-awesome-icon icon="plus-circle" size="1x" :style="{ color: '#359122'}"  class="IconoFontChico"/>
                  Agregar Análisis Suelo
                </div>
                <!-- HERRAMIENTAS NUEVAS  -->
                <router-link v-for="(herr, key) in Est.newHerramientas" class="OpcionMenu"
                  :key="key"
                  :to="Herramientas.GetRecordsPath(key, herr.IdEstHerr)"
                  >
                  <font-awesome-icon icon="eye" size="1x" :style="{ color: '#22878E'}"  class="IconoFontChico"/>
                  Ver <span class="">{{Herramientas.GetHerramientaById(key).title}}</span>
                </router-link>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
import axios from "axios";
import Clases from "../../Auxiliares/Clases.js";
import ModalNuevoEstablecimiento from '../../components/Utilidades/ModalNuevoEstablecimiento';
import SlidingPagination from 'vue-sliding-pagination';
import { Herramientas } from "../../Auxiliares/Enums";

export default {
  name: "Establecimientos",
  directives: {
    "clickoutside": {
      bind: function(el, binding) {
        // Define ourClickEventHandler
        const ourClickEventHandler = event => {
          if (!el.contains(event.target) && el !== event.target) {
            // as we are attaching an click event listern to the document (below)
            // ensure the events target is outside the element or a child of it
            binding.value(event); // before binding it
          }
        };
        // attached the handler to the element so we can remove it later easily
        el.__vueClickEventHandler__ = ourClickEventHandler;

        // attaching ourClickEventHandler to a listener on the document here
        document.addEventListener("click", ourClickEventHandler);
      },
      unbind: function(el) {
        // Remove Event Listener
        document.removeEventListener("click", el.__vueClickEventHandler__);
      }
    }
  },
  data() {
    return {
      Herramientas,
      RetornoAPI: {
        _NombreProductor: ""
      },
      ModalVisible: false,
      IdMenuVisible: 0,
      _UserOk: false,
      Error: null,
      AdminLogueado: false,
    };
  },
  mounted() {
    this._UserOk = this.$parent.Datos.ChequearSesionUsuario(this.$router);
    if (this._UserOk){
      this.AdminLogueado = this.$parent.Datos.AdminLogueado();
      if(this.AdminLogueado){
        this.ObtenerDatos();
      }
    }
  },
  methods: {
    ObtenerDatos() {
      var _This = this;
      try {
        axios
          .post(_This.urlPosts + "/AgroIdeas/Establecimientos", {
            IdUsuario: _This.$parent.Datos._User._ID,
            IdProductor: _This.$route.params.Id
          })
          .then(function (response) {
            _This.RetornoAPI = response.data;
            _This.GuardarDataEnCache(_This.RetornoAPI);
            _This.$refs.DivInfoData.classList.remove("Visible");
          })
          .catch(function (error) {
            _This.$refs.DivInfoData.classList.add("Visible");
          })
          .then(function () {});
      } catch (error) {
        console.log(error);
      }
    },
    IntentoObtenerDataDeCache(){
      var _Data = Clases.RecuperarJsonDeStorage(this.KeyDataCacheada());
      if (_Data != null){
        this.RetornoAPI = _Data._Json;
        this.$refs.FechaData.innerHTML = _Data._Fecha._FechaYHora;
      }
    },
    GuardarDataEnCache(_InfoAGuardar){
      var _Data = {
        _Fecha: new Clases.Fecha(new Date()),
        _Key: this.KeyDataCacheada(),
        _Json: _InfoAGuardar
      };
      Clases.GuardarJsonEnStorage(this.KeyDataCacheada(), _Data);
    },
    KeyDataCacheada(){
      return `InfoEstablecimientos_${this.$parent.Datos._User._ID}_${this.$route.params.Id}`;
    },
    VerModal() {
      this.ModalVisible = true;
    },
    CerrarModal() {
      this.ModalVisible = false;
    },
    NuevoEstablecimiento(){
      this.$refs.Modal.SetearPorNuevo(this.RetornoAPI._IdProductor);
      this.VerModal();
    },
    EditarEstablecimiento(_E){
      this.ModalVisible = true;
      this.$refs.Modal.Editar(_E);
    },
    EliminarEstablecimiento(_E){
      var _This = this;
      //alert(_Nombre);
      this.$confirm({
        title: "ATENCIÓN",
        message: "Estás seguro de eliminar el establecimiento " + _E._Nombre + "?",
        button: {
          yes: 'Si',
          no: 'No'
        },
        callback: confirm => {
          if(confirm){
            axios
              .post(_This.urlPosts + "/AgroIdeas/BajaEstablecimiento", {
                IdUsuario: _This.$parent.Datos._User._ID,
                IdEstablecimiento: _E._Id
              })
              .then(function (response) {
                if (response.data != ""){
                  _This.$parent.Notificacion(response.data, "", "success", 3);
                  _This.ObtenerDatos();
                }else{
                  _This.$parent.Notificacion("Error1!", "", "error", 3);
                }
              })
              .catch(function (error) {
                _This.$parent.Notificacion("Error!", "", "error", 3);
                console.error(error);
              })
              .then(function () {
                //console.log("Ok");//LLega siempre que no haya catch
              });
          }
        }
      })
    },
    OcultarMenu(){
      this.IdMenuVisible = 0;
    },
    ClickMenu(_Id, event){
      this.IdMenuVisible = _Id;
      let _IdElemento = "CM" + _Id;
      let _Elemento = document.getElementById(_IdElemento);
      let _AltoMenu = event.pageY + 120;
      if (event.pageY + 300 > screen.height){
        _AltoMenu = screen.height - 200;
        //console.log(_AltoMenu);
      }
      // if (event.pageX > screen.width/2){
      //   _AltoMenu = screen.height - 200;
      // }
      _Elemento.style.top = _AltoMenu + "px";
      // _Elemento.style.left = _AltoMenu + "px";
      // console.log(event.pageY);
      // console.log(screen.height);
    },
    VerPluviometro(_ID){
      this.$router.push(`${Herramientas.Pluviometros.path}/${_ID}`);
    },
    VerFreatimetro(_ID){
      this.$router.push(`${Herramientas.Freatimetros.path}/${_ID}`);
    },
    AltaPluviometro(_IdEst){
      var _This = this;
      try {
        axios
          .post(_This.urlPosts + "/AgroIdeas/AltaPluviometro", {
            IdUsuario: _This.$parent.Datos._User._ID,
            IdEstablecimiento: _IdEst
          })
          .then(function (response) {
            _This.ObtenerDatos();
            // _This.OcultarMenu();
            _This.$parent.Notificacion("Pluviómetro agregado!", "", "success", 3);
          })
          .catch(function (error) {
            console.error(error);
          })
          .then(function () {});
      } catch (error) {
        console.log(error);
      }
    },
    ConfirmarBajaPluviometro(_IdP, _NombreEst){
      this.$confirm({
        title: "ATENCIÓN",
        message: "Estás seguro de eliminar el Pluviómetro de " + _NombreEst + "?",
        button: {
          yes: 'Si',
          no: 'No'
        },
        callback: confirm => {
          if(confirm){ this.BajaPluviometro(_IdP); }
        }
      })
    },
    BajaPluviometro(_Id){
      var _This = this;
      try {
        axios
          .post(_This.urlPosts + "/AgroIdeas/BajaPluviometro", {
            IdUsuario: _This.$parent.Datos._User._ID,
            IdPluviometro: _Id
          })
          .then(function (response) {
            _This.ObtenerDatos();
            _This.$parent.Notificacion("Pluviómetro eliminado!", "", "success", 3);
          })
          .catch(function (error) {
            console.log(error.response);
            console.log(error.toString());
            console.log(error.toString().includes("Network error"));
          })
          .then(function () {});
      } catch (error) {
        console.log(error);
      }
    },
    AltaFreatimetro(_IdEst){
      var _This = this;
      try {
        axios
          .post(_This.urlPosts + "/AgroIdeas/AltaFreatimetro", {
            IdUsuario: _This.$parent.Datos._User._ID,
            IdEstablecimiento: _IdEst
          })
          .then(function (response) {
            _This.ObtenerDatos();
            // _This.OcultarMenu();
            _This.$parent.Notificacion("Freatímetro agregado!", "", "success", 3);
          })
          .catch(function (error) {
            console.error(error);
          })
          .then(function () {});
      } catch (error) {
        console.log(error);
      }
    },
    ConfirmarBajaFreatimetro(_IdF, _NombreEst){
      this.$confirm({
        title: "ATENCIÓN",
        message: "Estás seguro de eliminar el Freatímetro de " + _NombreEst + "?",
        button: {
          yes: 'Si',
          no: 'No'
        },
        callback: confirm => {
          if(confirm){ this.BajaFreatimetro(_IdF); }
        }
      })
    },
    BajaFreatimetro(_Id){
      var _This = this;
      try {
        axios
          .post(_This.urlPosts + "/AgroIdeas/BajaFreatimetro", {
            IdUsuario: _This.$parent.Datos._User._ID,
            IdFreatimetro: _Id
          })
          .then(function (response) {
            _This.ObtenerDatos();
            _This.$parent.Notificacion("Pluviómetro eliminado!", "", "success", 3);
          })
          .catch(function (error) {
            console.error(error);
          })
          .then(function () {});
      } catch (error) {
        console.log(error);
      }
    },
    VerVeris(_ID){
      this.$router.push("/veris/" + _ID);
    },
    AltaVeris(_IdEst){
      var _This = this;
      try {
        axios
          .post(_This.urlPosts + "/AgroIdeas/AltaVeris", {
            IdUsuario: _This.$parent.Datos._User._ID,
            IdEstablecimiento: _IdEst
          })
          .then(function (response) {
            _This.ObtenerDatos();
            // _This.OcultarMenu();
            _This.$parent.Notificacion("Veris agregado!", "", "success", 3);
          })
          .catch(function (error) {
            console.error(error);
          })
          .then(function () {});
      } catch (error) {
        console.log(error);
      }
    },
    ConfirmarBajaVeris(_Id, _NombreEst){
      this.$confirm({
        title: "ATENCIÓN",
        message: "Estás seguro de eliminar el Veris de " + _NombreEst + "?",
        button: {
          yes: 'Si',
          no: 'No'
        },
        callback: confirm => {
          if(confirm){ this.BajaVeris(_Id); }
        }
      })
    },
    BajaVeris(_Id){
      var _This = this;
      try {
        axios
          .post(_This.urlPosts + "/AgroIdeas/BajaVeris", {
            IdUsuario: _This.$parent.Datos._User._ID,
            IdVeris: _Id
          })
          .then(function (response) {
            _This.ObtenerDatos();
            _This.$parent.Notificacion("Veris eliminado!", "", "success", 3);
          })
          .catch(function (error) {
            console.error(error);
          })
          .then(function () {});
      } catch (error) {
        console.log(error);
      }
    },
    VerAguas(_ID){
      this.$router.push("/aguas/" + _ID);
    },
    AltaAguas(_IdEst){
      var _This = this;
      try {
        axios
          .post(_This.urlPosts + "/AgroIdeas/AltaAguas", {
            IdUsuario: _This.$parent.Datos._User._ID,
            IdEstablecimiento: _IdEst
          })
          .then(function (response) {
            _This.ObtenerDatos();
            // _This.OcultarMenu();
            _This.$parent.Notificacion("Análisis Agua agregado!", "", "success", 3);
          })
          .catch(function (error) {
            console.error(error);
          })
          .then(function () {});
      } catch (error) {
        console.log(error);
      }
    },
    ConfirmarBajaAguas(_Id, _NombreEst){
      this.$confirm({
        title: "ATENCIÓN",
        message: "Estás seguro de eliminar el Análisis Agua de " + _NombreEst + "?",
        button: {
          yes: 'Si',
          no: 'No'
        },
        callback: confirm => {
          if(confirm){ this.BajaAguas(_Id); }
        }
      })
    },
    BajaAguas(_Id){
      var _This = this;
      try {
        axios
          .post(_This.urlPosts + "/AgroIdeas/BajaAguas", {
            IdUsuario: _This.$parent.Datos._User._ID,
            Id: _Id
          })
          .then(function (response) {
            _This.ObtenerDatos();
            _This.$parent.Notificacion("Análisis Agua eliminado!", "", "success", 3);
          })
          .catch(function (error) {
            console.error(error);
          })
          .then(function () {});
      } catch (error) {
        console.log(error);
      }
    },
    VerSuelo(_ID){
      this.$router.push("/suelos/" + _ID);
    },
    AltaSuelo(_IdEst){
      var _This = this;
      try {
        axios
          .post(_This.urlPosts + "/AgroIdeas/AltaSuelo", {
            IdUsuario: _This.$parent.Datos._User._ID,
            IdEstablecimiento: _IdEst
          })
          .then(function (response) {
            _This.ObtenerDatos();
            // _This.OcultarMenu();
            _This.$parent.Notificacion("Análisis Suelo agregado!", "", "success", 3);
          })
          .catch(function (error) {
            console.error(error);
          })
          .then(function () {});
      } catch (error) {
        console.log(error);
      }
    },
    ConfirmarBajaSuelo(_Id, _NombreEst){
      this.$confirm({
        title: "ATENCIÓN",
        message: "Estás seguro de eliminar el Análisis Suelo de " + _NombreEst + "?",
        button: {
          yes: 'Si',
          no: 'No'
        },
        callback: confirm => {
          if(confirm){ this.BajaSuelo(_Id); }
        }
      })
    },
    BajaSuelo(_Id){
      var _This = this;
      try {
        axios
          .post(_This.urlPosts + "/AgroIdeas/BajaSuelo", {
            IdUsuario: _This.$parent.Datos._User._ID,
            Id: _Id
          })
          .then(function (response) {
            _This.ObtenerDatos();
            _This.$parent.Notificacion("Análisis Suelo eliminado!", "", "success", 3);
          })
          .catch(function (error) {
            console.error(error);
          })
          .then(function () {});
      } catch (error) {
        console.log(error);
      }
    }
  },
  components: {
    ModalNuevoEstablecimiento,
    SlidingPagination
  },
};
</script>

<style lang="scss" scoped>
  .c1{width:40%;}
  .c3{width:33%;}
  tr{
    cursor:pointer;
  }

  //#region "MenuOpciones"
  .MenuOpciones{
    width:30px; height:18px; position:relative; display:inline-block;
  }
  .ContenidoMenu{
    position:absolute;
    right: 30px; top: 18px;
    background-color: rgba(255, 255, 255, 0.99);
    min-width:200px;;
    width:550px;
    max-width:100%;
    z-index:100;
    border-radius:5px 5px 0 0;
    box-shadow:0 0 10px #666;
    box-sizing:border-box;
    overflow:hidden;
    height:auto;
    max-height:0px;
    position:fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding:10px;
    display:none;
  }
  .ContenidoMenu.Oculto{max-height:0px;
    padding:0px;
    border: none;
    display:none;
  }
  .ContenidoMenu.Visible{
    // padding:5px;
    // border:1px solid #444;
    max-height:600px;
    display:block;
  }
  .SeccionArrastre{
    background-color: #555; height:10px;
    width:100%;
    margin-bottom:10px;
  }
  .SpanEliminar{
    border-radius:20px; background-color: #922;
    color:white;
    padding:2px 5px;
    line-height:5px;
    height:5px;
  }
  .IconoFontChico{
    width:15px; height:15px;
  }
  .TrashIcon{
    position: absolute;
    top: 7px;
    right: 5px;
    width: 20px;
    height: 24px;
  }
  .OpcionMenu{
    width:100%;
    line-height:40px;
    padding:0 10px;
    box-sizing:border-box;
    text-align:left;
    height: 40px;
    display: block;
    position:relative;
    cursor:pointer;
    &:hover{
      background-color: rgba(0,0,0,0.1);
    }
    color:#555;
  }
  .BordeSuperior{
    border-top:1px solid rgba(0,0,0,0.6);
  }
  //#endregion

  .svg-inline--fa.fa-w-18, .svg-inline--fa.fa-w-14, .svg-inline--fa.fa-w-16 {
      width: auto !important;
      margin: 0 5px;
  }
  // .c1{min-width:50%; max-width:50%; display:inline-block; overflow:hidden;}
  // .c2{min-width:30%; max-width:30%; display:inline-block;}
  .button {
    background-color: #4caf50; /* Green */
    border: none;
    color: white;
    padding: 16px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    transition-duration: 0.4s;
    cursor: pointer;
    margin: 30px 0;
  }
  .Verde {
    background-color: white;
    color: black;
    border: 2px solid #4caf50;
  }

  .Verde:hover {
    background-color: #4caf50;
    color: white;
  }

  .Azul {
    background-color: white;
    color: black;
    border: 2px solid #008cba;
  }

  .Azul:hover {
    background-color: #008cba;
    color: white;
  }

  .Gris {
    background-color: white;
    color: black;
    border: 2px solid #e7e7e7;
  }

  .Gris:hover {
    background-color: #e7e7e7;
  }

  .Negro {
    background-color: white;
    color: black;
    border: 2px solid #555555;
  }

  .Negro:hover {
    background-color: #555555;
    color: white;
  }

</style>
